import Consent from "../../Models/Response/Consent/GetAllConsent";

const intiState: Consent = {
  numberOfPendingConsent: 0,
  numberOfFailedConsent: 0,
  numberOfActiveConsent: 0,
  activeConsent: [],
  pendingConsent: [],
  failedConsent: [],
};

export default function consent(state = intiState, action: any) {
  switch (action.type) {
    case "SAVE_CONSENT":
      return {
        ...state,
        consent: action.payload.consent,
      };

    default:
      return state;
  }
}
